import $ from "jquery";

const selectors = {
	resetPasswordForm: ".customer-page__reset-password-form",
	password: "#password",
	passwordConfirm: "#password_confirmation",
	strongPassword: ".js-strong-password",
	togglePassword: ".js-toggle-password",
	submitButton: ".js-reset-password-button"
};

const modifiers = {
	disabled: "disabled",
	toggled: "toggled",
	strongLevel1: "strong-password--level-1",
	strongLevel2: "strong-password--level-2",
	strongLevel3: "strong-password--level-3"
};

$(function () {
	if (!$(selectors.resetPasswordForm).length) {
		return;
	}

	function getStrongLevel(password) {
		let level = 0;
		if (password.length > 6) {
			level += 1;
			level += /[a-z]/.test(password) ? 1 : 0;
			level += /[A-Z]/.test(password) ? 1 : 0;
			level += /[0-9]/.test(password) ? 1 : 0;
			level += /[!@#$%^&*?_~<>]/.test(password) ? 1 : 0;
		}

		return level;
	}
	let $password = $(selectors.password);
	let $passwordConfirmation = $(selectors.passwordConfirm);
	let $strongPassword = $(selectors.strongPassword);
	let $togglePassword = $(selectors.togglePassword);
	let $submitButton = $(selectors.submitButton);

	$togglePassword.on("click", function (e) {
		e.preventDefault();
		$(this).toggleClass(modifiers.toggled);
		if ($password.attr("type") === "password") {
			$password.attr("type", "text");
		} else {
			$password.attr("type", "password");
		}
	});

	$password.on("input", function () {
		let strongLevel = getStrongLevel($(this).val());

		if ($(this).val() === $passwordConfirmation.val()) {
			$submitButton.removeClass("disabled");
		} else {
			$submitButton.addClass("disabled");
		}

		switch (strongLevel) {
			case 0:
			case 1:
			case 2:
				$strongPassword.removeClass([
					modifiers.strongLevel2,
					modifiers.strongLevel3
				]);
				$strongPassword.addClass(modifiers.strongLevel1);
				break;
			case 3:
			case 4:
				$strongPassword.removeClass([
					modifiers.strongLevel1,
					modifiers.strongLevel3
				]);
				$strongPassword.addClass(modifiers.strongLevel2);
				break;
			case 5:
				$strongPassword.removeClass([
					modifiers.strongLevel1,
					modifiers.strongLevel2
				]);
				$strongPassword.addClass(modifiers.strongLevel3);
				break;
		}
	});

	$passwordConfirmation.on("input", function () {
		if ($(this).val() === $password.val() && $password.val().length > 6) {
			$submitButton.removeClass("disabled");
		} else {
			$submitButton.addClass("disabled");
		}
	});
});
